export interface TopicStep {
  index: number;
  label: string;
  description: string;
  // The topic attribute this step edits.
  valueKey: string;
}

export default [
  {
    index: 1,
    label: 'Learning intentions',
    description:
      'Learning intentions are clear, curriculum-aligned statements that describe what students should learn or do...',
    valueKey: 'learningIntentions',
  },
  {
    index: 2,
    label: 'Key Questions',
    description:
      'Questions to deepen thinking, assess understanding, and create inclusive participation structures.',
    valueKey: 'keyQuestions',
  },
  {
    index: 3,
    label: 'Success Criteria',
    description:
      'Success criteria should be co-constructed with students where possible and should use student-friendly language.',
    valueKey: 'successCriteria',
  },
  {
    index: 4,
    label: 'Connections',
    description:
      'Help students connect new learning to prior knowledge, skills, and experiences to deepen understanding.',
    valueKey: 'learningConnections',
  },
  {
    index: 5,
    label: 'Assessment Tasks',
    description: 'Possible assessment opportunities or tasks.',
    valueKey: 'assessmentTasks',
  },
  {
    index: 6,
    label: 'Teaching Strategies',
    description: 'Possible teaching approaches and steps.',
    valueKey: 'teachingStrategies',
  },
  {
    index: 7,
    label: 'Exemplars',
    description: 'Examples of quality work.',
    valueKey: 'goalExemplar',
  },
] satisfies TopicStep[];
